"use client";

import React, { useState } from "react";
import { Heart, Share2, ChevronsLeftRight, Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const galleryItems = [{
  id: 1,
  type: "fade",
  isBeforeAfter: true,
  beforeSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/gallery_fade_before_1.png",
  afterSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/hekappers_1717609339_3383874861392799948_7128222511_1.webp",
  title: "Moderne Skin Fade",
  description: "Messcherpe overloop met een gestructureerde top."
}, {
  id: 2,
  type: "classic",
  isBeforeAfter: false,
  src: "https://literate-katydid.10web.cloud/wp-content/uploads/2026/05/hekappers_1747132030_3631529141543874307_7128222511_1-1.jpg?v=pl0ecni5tdl",
  title: "Moderne Mullet",
  description: "Tijdloze elegantie met een moderne twist."
}, {
  id: 3,
  type: "beard",
  isBeforeAfter: false,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/hekappers_1714214147_3355393648016570668_7128222511_1.webp",
  title: "Luxe Baard Trim",
  description: "Strakke contouren en een volle, verzorgde look."
}, {
  id: 4,
  type: "fade",
  isBeforeAfter: false,
  src: "https://literate-katydid.10web.cloud/wp-content/uploads/2026/05/hekappers_1747042020_3630774082526575616_7128222511_1-1.webp?v=a3q01q0fjda",
  title: "Textured Crop Fade",
  description: "Moderne textuur gecombineerd met een strakke fade."
}, {
  id: 5,
  type: "classic",
  isBeforeAfter: false,
  src: "https://literate-katydid.10web.cloud/wp-content/uploads/2026/05/hekappers_1714029303_3353843629535888124_7128222511_1-1.jpg?v=7uvkcx7dnpd",
  title: "Executive Contour",
  description: "De perfecte snit voor de zakelijke gentleman."
}, {
  id: 7,
  type: "fade",
  isBeforeAfter: false,
  src: "https://literate-katydid.10web.cloud/wp-content/uploads/2026/05/hekappers_1713998417_3353584248214966742_7128222511_1.webp?v=tnyveyi1vg",
  title: "Low Taper Fade",
  description: "Subtiele afwerking voor een verfijnde uitstraling."
}];
function BeforeAfterSlider({
  beforeSrc,
  afterSrc,
  alt
}: {
  beforeSrc: string;
  afterSrc: string;
  alt: string;
}) {
  const [position, setPosition] = useState(50);
  return <div data-section-id="80671" className="relative w-full aspect-[4/5] overflow-hidden group/slider bg-muted">
      {}
      <img src={afterSrc} alt={`Na - ${alt}`} className="absolute inset-0 w-full h-full object-cover sepia-[.15] contrast-[1.1] saturate-[1.1]" loading="lazy" />
      
      {}
      <img src={beforeSrc} alt={`Voor - ${alt}`} className="absolute inset-0 w-full h-full object-cover sepia-[.15] contrast-[1.1] saturate-[1.1]" style={{
      clipPath: `polygon(0 0, ${position}% 0, ${position}% 100%, 0 100%)`
    }} loading="lazy" />

      {}
      <div className="absolute top-0 bottom-0 w-0.5 bg-primary pointer-events-none" style={{
      left: `calc(${position}%)`
    }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-background rounded-lg border-2 border-primary flex items-center justify-center shadow-lg">
          <ChevronsLeftRight className="w-4 h-4 text-primary" />
        </div>
      </div>

      {}
      <input type="range" min="0" max="100" value={position} onChange={e => setPosition(Number(e.target.value))} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-10" aria-label="Vergelijk voor en na" />

      {}
      <div className="absolute bottom-4 left-4 bg-background/90 backdrop-blur-sm text-foreground px-2.5 py-1 text-[10px] font-bold rounded uppercase tracking-widest pointer-events-none opacity-0 group-hover/slider:opacity-100 transition-opacity duration-300 border border-border/50">
        Voor
      </div>
      <div className="absolute bottom-4 right-4 bg-primary/90 backdrop-blur-sm text-primary-foreground px-2.5 py-1 text-[10px] font-bold rounded uppercase tracking-widest pointer-events-none opacity-0 group-hover/slider:opacity-100 transition-opacity duration-300 shadow-md">
        Na
      </div>
    </div>;
}
export default function DeHeErvaringInBeeld() {
  const [activeFilter, setActiveFilter] = useState("all");
  const filteredItems = galleryItems.filter(item => activeFilter === "all" || item.type === activeFilter);
  return <section id="de-he-lookbook" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <TooltipProvider delayDuration={300}>
        <div className="max-w-7xl mx-auto">
          {}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-sm font-mono tracking-widest text-primary uppercase mb-4">
              Portfolio
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-foreground tracking-tight">
              De H&E Lookbook
            </h3>
            <p className="text-muted-foreground text-lg leading-relaxed">
              Ontdek de kunst van precisie. Onze galerij toont de perfectie in elke fade, 
              de strakke lijnen van elke baard en de tijdloze klasse van onze 
              herensnitten. Vind inspiratie voor uw volgende bezoek.
            </p>
          </div>

          {}
          <div className="flex justify-center mb-12">
            <ToggleGroup type="single" value={activeFilter} onValueChange={value => {
            if (value) setActiveFilter(value);
          }} variant="outline" className="bg-card/50 backdrop-blur-sm border-border/50 p-1 rounded-lg shadow-md">
              <ToggleGroupItem value="all" className="px-6 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground transition-all duration-300 font-medium">
                Alle Stijlen
              </ToggleGroupItem>
              <ToggleGroupItem value="fade" className="px-6 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground transition-all duration-300 font-medium">
                Fades
              </ToggleGroupItem>
              <ToggleGroupItem value="classic" className="px-6 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground transition-all duration-300 font-medium">
                Klassiek
              </ToggleGroupItem>
              <ToggleGroupItem value="beard" className="px-6 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground transition-all duration-300 font-medium">
                Baarden
              </ToggleGroupItem>
            </ToggleGroup>
          </div>

          {}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
            {filteredItems.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid relative group rounded-lg overflow-hidden bg-card border border-border/30 shadow-lg hover:border-primary/50 transition-all duration-500">
                {}
                {item.isBeforeAfter && i !== 0 ? <BeforeAfterSlider beforeSrc={item.beforeSrc!} afterSrc={item.afterSrc!} alt={item.title} /> : item.isBeforeAfter && i === 0 ? <div className="relative w-full aspect-[4/5] overflow-hidden bg-muted">
                    <img src={item.afterSrc} data-wvc-srcset={`${item.afterSrc}-wvc-srcset`} data-wvc-sizes={`${item.afterSrc}-wvc-sizes`} alt={item.title} className="w-full h-full object-cover sepia-[.15] contrast-[1.1] saturate-[1.1] group-hover:scale-105 transition-transform duration-700 ease-out" loading="lazy" />
                  </div> : <div className="relative w-full overflow-hidden bg-muted">
                    <img src={item.src} alt={item.title} className="w-full h-auto object-cover sepia-[.15] contrast-[1.1] saturate-[1.1] group-hover:scale-105 transition-transform duration-700 ease-out" loading="lazy" />
                  </div>}

                {}
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none flex flex-col justify-end p-6">
                  <h4 className="text-primary font-serif text-xl font-bold translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    {item.title}
                  </h4>
                  <p className="text-white/90 text-sm mt-2 translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75">
                    {item.description}
                  </p>
                </div>

                {}
                <div className="absolute top-4 right-4 flex flex-col gap-2 z-20 opacity-0 group-hover:opacity-100 translate-x-4 group-hover:translate-x-0 transition-all duration-300">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button size="icon" variant="secondary" className="w-9 h-9 rounded-sm bg-background/80 backdrop-blur-md hover:bg-primary hover:text-primary-foreground border border-border/50 shadow-md">
                        <Heart className="w-4 h-4" />
                        <span className="sr-only">Vind ik leuk</span>
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left" className="font-medium bg-secondary text-secondary-foreground border-border">
                      Vind ik leuk
                    </TooltipContent>
                  </Tooltip>

                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button size="icon" variant="secondary" className="w-9 h-9 rounded-sm bg-background/80 backdrop-blur-md hover:bg-primary hover:text-primary-foreground border border-border/50 shadow-md">
                        <Share2 className="w-4 h-4" />
                        <span className="sr-only">Delen</span>
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left" className="font-medium bg-secondary text-secondary-foreground border-border">
                      Delen
                    </TooltipContent>
                  </Tooltip>
                  
                  {(!item.isBeforeAfter || item.isBeforeAfter && i === 0) && <Tooltip>
                     <TooltipTrigger asChild>
                       <Button size="icon" variant="secondary" className="w-9 h-9 rounded-sm bg-background/80 backdrop-blur-md hover:bg-primary hover:text-primary-foreground border border-border/50 shadow-md">
                         <Maximize2 className="w-4 h-4" />
                         <span className="sr-only">Vergroten</span>
                       </Button>
                     </TooltipTrigger>
                     <TooltipContent side="left" className="font-medium bg-secondary text-secondary-foreground border-border">
                       Vergroten
                     </TooltipContent>
                   </Tooltip>}
                </div>
              </div>)}
          </div>
          
          {}
          {filteredItems.length === 0 && <div className="text-center py-24 text-muted-foreground">
              <p className="font-medium">Geen resultaten gevonden voor deze categorie.</p>
            </div>}
        </div>
      </TooltipProvider>
    </section>;
}